export default __webpack_public_path__ + "static/media/endorsement-pertamina-archery.5bc01f05.png";